module.exports = __webpack_public_path__ + "img/camera-polaroid.b2928b75.svg";